import { UnstyledButton } from "@mantine/core";
import type { ComponentPropsWithRef, ReactNode } from "react";

import classes from "./Pill.module.css";

export interface PillProps extends Omit<ComponentPropsWithRef<"button">, "children"> {
  label: ReactNode;
  /** A 16px icon before the label. */
  icon?: ReactNode;
  /** The setting is on, or its menu is open. */
  active?: boolean;
}

/**
 * A 36px setting pill of the generation panel (design-system.md 3.3): an icon and a label, soft
 * primary when active. It is a button, so it can open a menu (Mantine's targets pass their ref).
 */
export function Pill({ label, icon, active = false, disabled, ...button }: PillProps) {
  // Disabled for real, or only marked so (`Soon`): either way it looks it.
  const off = disabled === true || button["aria-disabled"] === true;
  return (
    <UnstyledButton
      {...button}
      disabled={disabled}
      className={classes.pill}
      data-active={active || undefined}
      data-disabled={off || undefined}
    >
      {icon}
      <span className={classes.label}>{label}</span>
    </UnstyledButton>
  );
}
